<template>
    <div class="notes-panel-container" :style="{height: `calc(100% - ${chapterWrapHeaderHeight}px)`}">
        <v-container id="notes-filter-container" class="pt-0 pb-0">
            <v-row dense>
                <v-col class="d-flex align-center">
                    <span class="font-weight-bold">{{ totalNotes }} note{{totalNotes === 1 ? '' : 's'}}</span>
                </v-col>
                <v-col class="text-right">
                    <v-badge
                        v-if="isFilterApplied"
                        color="success"
                        overlap
                        dot>
                            <v-btn
                                icon
                                v-on:click="filterToggle = !filterToggle">
                                <v-icon>
                                    mdi-filter-variant
                                </v-icon>
                            </v-btn>
                    </v-badge>
                    <v-btn
                        v-else
                        icon
                        v-on:click="filterToggle = !filterToggle">
                        <v-icon>
                            mdi-filter-variant
                        </v-icon>
                    </v-btn>
                    <v-menu
                        left
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                icon
                                v-on:click="on.click"
                            >
                                <v-icon>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item-group>
                                <v-list-item  @click="!freeView ? goToRoute('notes') : null">
                                    <v-list-item-icon class="mr-2">
                                        <v-icon>mdi-cog-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Manage notes</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!activeEnterpriseProfile" @click="!freeView ? migrateNotes() : null">
                                    <v-list-item-icon class="mr-2">
                                        <v-icon>mdi-swap-horizontal</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Move notes</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row dense v-if="filterToggle">
                <v-col>
                    <v-autocomplete
                        outlined
                        dense
                        v-model="tag_value"
                        :items="tag_categories"
                        item-text="tag"
                        item-value="id"
                        clearable
                        hide-details
                        chips
                        small-chips
                        deletable-chips
                        class="filter-by-tag white mb-3"
                        label="Project Tag"
                        multiple
                        :menu-props="{ bottom: true, offsetY: true }">
                    </v-autocomplete>
                    <v-autocomplete
                        v-if="isEnterpriseOrConcurrentActive"
                        outlined
                        dense
                        v-model="selectedUsers"
                        :items="noteBookmarkUsers"
                        item-text="name"
                        item-value="id"
                        clearable
                        hide-details
                        chips
                        small-chips
                        deletable-chips
                        class="filter-by-tag white mb-3"
                        label="Created By"
                        multiple
                        :menu-props="{ bottom: true, offsetY: true }">
                    </v-autocomplete>
                </v-col>
            </v-row>
        </v-container>
        <v-divider/>
        <v-container
            :style="{background: $vuetify.theme.themes.light.primaryLight}"
            class="overflow-auto notes-content-container">
            <trial-action
                    v-if="freeView"
                title="Bookmark and add notes to code sections"
                content="Organize thoughts by bookmarking sections and adding notes that you can refer to anytime.">
            </trial-action>
            <template v-else-if="!freeView && (loading_tags || loading_notes)">
                <v-row>
                    <v-col class="text-center">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </v-col>
                </v-row>
            </template>
            <template v-else>
                <v-row v-if="notesCheck">
                    <v-col class="py-0">
                        <template v-for="(note, index) in chapter_notes">
                            <v-row
                                :class="{
                                    'lightgreen accent2--text': activeNote(note.section_number)
                                }"
                                :key="index">
                                <v-col class="py-1">
                                    <p class="mb-0">
                                        <a
                                            class="toc-chapter-item-focused"
                                            tabindex="0"
                                            @click="showContent(note, true)"
                                            v-html="chaptersTitle(note, true)"
                                            @keydown.enter="showContent(note, true)">
                                        </a>
                                    </p>
                                </v-col>
                            </v-row>
                        </template>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col>
                        <p class="caption text-center">You currently do not have any annotations or bookmarks for this book.</p>
                    </v-col>
                </v-row>
            </template>
            <v-dialog
                persistent
                v-model="dialog"
                width="700">
                <v-card>
                    <v-card-title
                        class="primary white--text"
                        primary-title>
                        Move Notes
                    </v-card-title>
                    <v-card-text>
                        <p class="text-center pt-8">
                            You currently do not have any notes to be moved right now.
                        </p>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="dialog = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
    import Legend from '../inc/mixins/legend';
    import TrialAction from './TrialAction.vue';

    export default {
        components: { TrialAction },
        data() {
            return {
                totalNotes: 0,
                chapter_notes: [],
                tag_categories: [],
                noteBookmarkUsers:[],
                tag_value: [],
                selectedUsers: [],
                loading_tags: false,
                loading_notes: false,
                loading_users: false,
                dialog: false,
                subscribeModal: false,
                chapterWrapHeaderHeight: 0,
                filterToggle: false
            }
        },
        props: {
            documentInfo: {
                required: true,
                type: Object
            },
            freeView: {
                type: Boolean,
                required: false
            }
        },
        mixins: [Legend],
        computed: {
            notesCheck() {
                if (_.size(this.chapter_notes) > 0) {
                    return true;
                }
                return false;
            },
            isFilterApplied(){
                if (this.tag_value.length || this.selectedUsers.length) {
                    return true;
                }
                return false;
            }
        },
        watch: {
            tag_value: function(value) {
                if (this.isXML && this.$store.getters.getLoggedIn) {
                    let filters = {
                        tags: value,
                        users: this.selectedUsers
                    }
                    EventBus.fire('filter-chapter-notes',filters);
                    this.getNotes();
                }
            },
            selectedUsers: function(value) {
                if (this.isXML && this.$store.getters.getLoggedIn) {
                    let filters = {
                        tags: this.tag_value,
                        users: value
                    }
                    EventBus.fire('filter-chapter-notes',filters);
                    this.getNotes();
                }
            }
        },
        methods: {
            getTags() {
                this.loading_tags = true;
                this.$http.get(Routing.generate('get_legend_tags', {'documentId': this.documentInfo.document_id})).then(
                    response => {
                        if (response.data) {
                            this.tag_categories = _.sortBy(this.toArray(response.data), ['tag']);
                        }
                        this.loading_tags = false;
                    }
                )
            },
            getAnnotationBookmarkUsers() {
                if (!this.isEnterpriseOrConcurrentActive) {
                    return;
                }
                this.loading_users = true;
                this.$http.get(Routing.generate('get_annotation_bookmark_users',
                    {'documentId': this.documentInfo.document_id}))
                    .then((response) => {
                        if (response.data) {
                            this.noteBookmarkUsers = response.data;
                        }
                    })
                    .finally(()=>{
                        this.loading_users = false;
                    })
            },
            getNotes() {
                this.loading_notes = true;
                let data = {
                    'sku': [this.documentInfo.sku],
                    'action': 'legend_notes',
                    'tags': this.tag_value,
                    'users': this.selectedUsers
                };

                this.$http.get(Routing.generate('get_annotation_bookmarks', data)).then(
                    response => {
                        if (response.data) {
                            this.subscribeModal = response.data.subscribeModal;
                            let chapters = [];
                            let totalUniqueNotes = 0;
                            _.each(response.data, function(item, key) {
                                if(!isNaN(key) && item !== undefined) {
                                    let contentId = _.parseInt(item.section_number);

                                    // Check if the chapter already exists in chapters array
                                    let existingChapter = _.find(chapters, { content_id: contentId });

                                    if (existingChapter) {
                                        // If the chapter exists, increment its count
                                        existingChapter.count += 1;
                                    } else {
                                        let data = {
                                            'content_id': contentId,
                                            'link': {
                                                'id': item.isFigure === '1' ? item.figureId : item.section_number,
                                                'title': item.section_title || item.chapter_title
                                            },
                                            'parentContentID': item.content_id,
                                            'sortorder': item.isFigure === '1' ? item.bookmarkId : 0,
                                            'section_number': item.section_number,
                                            'count': 1
                                        };
                                        chapters.push(data);
                                    }

                                    totalUniqueNotes++;
                                }
                            });

                            this.chapter_notes = chapters;
                            this.totalNotes = totalUniqueNotes;
                        }
                        this.loading_notes = false;
                    }
                )

            },
            redirectToUserNotes() {
                window.location = Routing.generate('notes');
            },
            activeNote(section){
                return section === this.$store.getters.getActiveSection;
            },
            migrateNotes() {
                if(_.size(this.chapter_notes)) {
                    window.location = Routing.generate('migrate_notes', {'documentId': this.documentInfo.document_id});
                } else {
                    this.dialog = true;
                }
            },
        },
        created() {
            if (!this.freeView) {
                EventBus.listen('get-tags', () => this.getTags());
                EventBus.listen('get-notes', () =>{
                    this.getAnnotationBookmarkUsers();
                    this.getNotes()
                });
            }
        },
        mounted() {
            if (!this.freeView) {
                this.getTags();
                this.getAnnotationBookmarkUsers();
                this.getNotes();
            }
            const element = document.querySelector('.notes-panel-container');
            if (element) {
                const rect = element.getBoundingClientRect();
                this.chapterWrapHeaderHeight = rect.top;

            }
        }
    }
</script>
<style scoped>
    .filter-by-tag .v-list {
        background: #fff;
    }
    .disable-btn{
        cursor: default;
    }

    .notes-panel-container {
        display: flex;
        flex-direction: column;
    }

    #notes-filter-container {
        flex: 0 1 auto;
    }

    .notes-content-container {
        flex: 1 1 auto;
        overflow: auto;
    }
</style>
